import AuthenticationStore from './AuthenticationStore';
import ConfigurationStore from './ConfigurationStore';
import ReportStore from './ReportStore';
import OrganizationStore from './OrganizationStore';

class RootStore {
  authenticationStore : AuthenticationStore;
  configurationStore : ConfigurationStore;
  reportStore : ReportStore;
  organizationStore : OrganizationStore;

  constructor() {
    this.authenticationStore = new AuthenticationStore(this);
    this.configurationStore = new ConfigurationStore(this);
    this.reportStore = new ReportStore(this);
    this.organizationStore = new OrganizationStore(this);
  }

  getStores() {
    return {
      authenticationStore: this.authenticationStore,
      configurationStore: this.configurationStore,
      reportStore: this.reportStore,
      organizationStore: this.organizationStore
    }
  }
}

const rootStore = new RootStore();
export default rootStore;

export type AllStores = {
  authenticationStore : AuthenticationStore;
  configurationStore : ConfigurationStore;
  reportStore : ReportStore;
  organizationStore : OrganizationStore;
};

export { 
  RootStore
};
